import { CourseDegreeCopy } from '../models/course-degree-hub.models';

export const UNDERGRADUATE_DATA: CourseDegreeCopy = {
	degreeLevel: 'undergraduate',
	metadata: {
		title: 'Search Undergraduate Courses, UK',
		description:
			'Discover undergraduate courses in the UK. Explore student reviews, fees, grants, and find information on undergraduate courses at Uni Compare.',
	},
	headerData: {
		title: 'Undergraduate courses',
		description:
			"Use our undergraduate courses search to find a course at a UK university. Explore undergraduate courses by subject, course name or the region you'd like to study in. Easily find the perfect undergraduate courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover undergraduate courses',
		description:
			'Undergraduate courses are your first step into higher education and will allow you to expand your knowledge in your chosen area. Explore undergraduate courses, from Archaeology all the way to Zoology right here!',
	},
	directoryCard: {
		title: 'Undergraduate directory',
		link: '/directory/undergraduate',
	},
	showClearingAndDirectoryCTA: true,
	showDegreeLevelHubLinks: true,
	showViewAllSubjectsLink: false,
	degreeLevelLabels: [
		'Undergraduate',
		"Bachelor's",
		'Foundation',
		'Undergraduate Certificates & Diplomas',
	],
};

export const UNDERGRADUATE_CERTIFICATE_DIPLOMAS_DATA: CourseDegreeCopy = {
	degreeLevel: 'undergraduate-certificate-diplomas',
	metadata: {
		title: 'Search Undergraduate Certificates & Diplomas, UK',
		description:
			'Discover undergraduate certificates and diplomas in the UK. Explore student reviews, fees, grants, and find information on undergraduate certificates and diplomas at Uni Compare.',
	},
	headerData: {
		title: 'Undergraduate certificates and diplomas',
		description:
			"Discover undergraduate certificates and diplomas across the UK. Here, you'll find HND and HNC courses, as well as other pre-degrees with Foundation and Access to Higher Education. Explore by subject, filter to regions of the UK and find the perfect undergraduate certificates and diploma for you.",
	},
	pageIntro: {
		title: 'Discover undergraduate certificates and diplomas',
		description:
			"Undergraduate certificate and diplomas allow you to level up your learning in a particular field. Discover vocational certificates like a HNC to get you set for your career, and diplomas like a HND to specialise your learning. Here, you'll also find Access to Higher Education and Foundation courses. Take a look at your options, view entry requirements, study options and more to make the right decision for you.",
	},
	showClearingAndDirectoryCTA: true,
	showDegreeLevelHubLinks: true,
	showViewAllSubjectsLink: false,
	degreeLevelLabels: [
		'Undergraduate Certificates & Diplomas',
		'Undergraduate',
		"Bachelor's",
		'HND',
		'HNC',
		'Foundation',
		'Access to Higher Education',
	],
};

export const POSTGRADUATE_DATA: CourseDegreeCopy = {
	degreeLevel: 'postgraduate',
	metadata: {
		title: 'Search Postgraduate Courses, UK',
		description:
			'Discover postgraduate courses in the UK. Explore student reviews, fees, grants, and find information on postgraduate courses at Uni Compare.',
	},
	headerData: {
		title: 'Postgraduate courses',
		description:
			"Use our postgraduate courses search to find a course at a UK university. Explore postgraduate courses by subject, course name or the region you'd like to study in. Easily find the perfect postgraduate courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Explore postgraduate courses',
		description:
			"Looking to continue your academic journey? Postgraduate courses will see you specialise further, undertaking independent study and developing your academic skills. Whether it's a Master's degree, postgraduate qualification or PhD, explore options across hundreds of subjects and universities across the country.",
	},
	directoryCard: {
		title: 'Postgraduate directory',
		link: '/directory/postgraduate',
	},
	showClearingAndDirectoryCTA: true,
	showDegreeLevelHubLinks: true,
	showViewAllSubjectsLink: false,
	degreeLevelLabels: [
		'Postgraduate',
		"Master's",
		'PhD',
		'Postgraduate Certificates & Diplomas',
	],
};

export const POSTGRADUATE_CERTIFICATE_DIPLOMAS_DATA: CourseDegreeCopy = {
	degreeLevel: 'postgraduate-certificate-diplomas',
	metadata: {
		title: 'Search Postgraduate Certificates & Diplomas, UK',
		description:
			'Discover Postgraduate certificates and diplomas in the UK. Explore student reviews, fees, grants, and find information on postgraduate certificates and diplomas at Uni Compare.',
	},
	headerData: {
		title: 'Postgraduate certificates and diplomas',
		description:
			'Discover postgraduate certificates and diplomas across the UK. Explore by subject, specify course type include PGCert and PGDip, and filter to certain regions of the UK. Easily find the perfect postgraduate certificates and diplomas with our search tool from thousands of options.',
	},
	pageIntro: {
		title: 'Discover postgraduate certificates and diplomas',
		description:
			"Whether you're looking to continue your studies after your undergrad, or your coming back to education to level up your learning for your job, there are a variety of postgraduate certificates and diplomas, including PGCert and PGDip. Find out more about study options, entry requirements and more right here.",
	},
	showClearingAndDirectoryCTA: true,
	showDegreeLevelHubLinks: true,
	showViewAllSubjectsLink: false,
	degreeLevelLabels: [
		'Postgraduate',
		"Master's",
		'PGCE courses',
		'PhD',
		'Postgraduate Diploma',
		'Postgraduate Certificate',
		'Postgraduate Certificates & Diplomas',
	],
};

export const HND_DATA: CourseDegreeCopy = {
	degreeLevel: 'hnd',
	metadata: {
		title: 'Search HND Courses, UK',
		description:
			'Discover HND courses in the UK. Explore student reviews, fees, grants, and find information on HND courses at Uni Compare.',
	},
	headerData: {
		title: 'HND courses',
		description:
			"Use our HND courses search to find a course at a UK university. Explore HND courses by subject, course name or the region you'd like to study in. Easily find the perfect HND courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover HND courses',
		description:
			"With a HND (Higher National Diploma) qualification, you'll gain the knowledge and practical skills needed to kickstart your career. Search for HND courses available up and down the country, as well as information on course options, entry requirements and more.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'HND',
		'Undergraduate',
		"Bachelor's",
		'Foundation',
		'Undergraduate Certificates & Diplomas',
	],
};

export const HNC_DATA: CourseDegreeCopy = {
	degreeLevel: 'hnc',
	metadata: {
		title: 'Search HNC Courses, UK',
		description:
			'Discover HNC courses in the UK. Explore student reviews, fees, grants, and find information on HNC courses at Uni Compare.',
	},
	headerData: {
		title: 'HNC courses',
		description:
			"Use our HNC courses search to find a course at a UK university. Explore HNC courses by subject, course name or the region you'd like to study in. Easily find the perfect HNC courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Explore HNC courses',
		description:
			'HNC (Higher National Certificate) courses help you gain the necessary skills to excel in your career. Discover course options that support vocational careers, as well as all the entry requirements and funding information you need.',
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'HNC',
		'Undergraduate',
		"Bachelor's",
		'Foundation',
		'Undergraduate Certificates & Diplomas',
	],
};

export const MASTERS_DATA: CourseDegreeCopy = {
	degreeLevel: 'masters',
	metadata: {
		title: "Search Master's Degrees, UK",
		description:
			"Discover Master's degrees in the UK. Explore student reviews, fees, grants, and find information on Master's degrees at Uni Compare.",
	},
	headerData: {
		title: "Master's degrees",
		description:
			"Use our Master's degrees search to find a course at a UK university. Explore Master's degrees by subject, course name or the region you'd like to study in. Easily find the perfect Master's degrees with our search tool from thousands of options.",
	},
	pageIntro: {
		title: "Discover Master's degree programmes",
		description:
			"Find the right Master's degree for you! Explore thousands of Master's degree programmes that cover a huge selection of subjects to allow you to find the specialism you want to pursue.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		"Master's",
		'Postgraduate',
		'PhD',
		'Postgraduate Certificates & Diplomas',
	],
};

export const PGCE_DATA: CourseDegreeCopy = {
	degreeLevel: 'pgce',
	metadata: {
		title: 'Search PGCE Courses, UK',
		description:
			'Discover PGCE courses in the UK. Explore student reviews, fees, grants, and find information on PGCE courses at Uni Compare.',
	},
	headerData: {
		title: 'PGCE courses',
		description:
			"Use our PGCE courses search to find a course at a UK university. Explore PGCE courses by subject, course name or the region you'd like to study in. Easily find the perfect PGCE courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Search PGCE courses',
		description:
			"Take on teacher training and search PGCE courses available across the country. You'll have all the information about course options, entry requirements, funding and more right at your fingertips.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'PGCE courses',
		'Postgraduate',
		"Master's",
		'PhD',
		'Postgraduate Certificates & Diplomas',
	],
};
export const PHD_DATA: CourseDegreeCopy = {
	degreeLevel: 'phd',
	metadata: {
		title: 'Search PhD Degrees, UK',
		description:
			'Discover PhD degrees in the UK. Explore student reviews, fees, grants, and find information on PhD degrees at Uni Compare.',
	},
	headerData: {
		title: 'PhD degrees',
		description:
			"Use our PhD degrees search to find a course at a UK university. Explore PhD degrees by subject, course name or the region you'd like to study in. Easily find the perfect PhD degrees with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Find PhD degree programmes',
		description:
			"A PhD is the final stop on your higher education journey, so you'll want to take the time to explore your options and find the perfect fit. Search PhD degree programmes by subject and learn more about the individual programmes - entry requirements, course content, funding options and so much more.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'PhD',
		'Postgraduate',
		"Master's",
		'Postgraduate Certificates & Diplomas',
	],
};

export const POSTGRADUATE_DIPLOMA_DATA: CourseDegreeCopy = {
	degreeLevel: 'postgraduate-diploma',
	metadata: {
		title: 'Search Postgraduate Diplomas, UK',
		description:
			'Discover Postgraduate Diplomas in the UK. Explore student reviews, fees, grants, and find information on Postgraduate Diplomas at Uni Compare.',
	},
	headerData: {
		title: 'Postgraduate Diplomas',
		description:
			"Use our Postgraduate Diplomas search to find a course at a UK university. Explore Postgraduate Diplomas by subject, course name or the region you'd like to study in. Easily find the perfect Postgraduate Diplomas with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover Postgraduate Diploma (PGDip) courses',
		description:
			'A Postgraduate Diploma (PGDip) gives you specialist training so you can excel in your chosen career. Discover course options from universities and colleges up and down the country, learn more about the course content and make the right choice for you.',
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'Postgraduate Diploma',
		'Postgraduate',
		"Master's",
		'PhD',
		'Postgraduate Certificates & Diplomas',
	],
};

export const POSTGRADUATE_CERTIFICATE_DATA: CourseDegreeCopy = {
	degreeLevel: 'postgraduate-certificate',
	metadata: {
		title: 'Search Postgraduate Certificates, UK',
		description:
			'Discover Postgraduate Certificates in the UK. Explore student reviews, fees, grants, and find information on Postgraduate Certificates at Uni Compare.',
	},
	headerData: {
		title: 'Postgraduate Certificates',
		description:
			"Use our Postgraduate Certificates search to find a course at a UK university. Explore Postgraduate Certificates by subject, course name or the region you'd like to study in. Easily find the perfect postgraduate certificates with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover Postgraduate Certificate (PGCert) courses',
		description:
			"A Postgraduate Certificate (PGCert) will expand your skills and help you land your dream job! You'll specialise in a chosen field to undertake hands-on training ready for the working world. Browse hundreds of PGCert courses and find the right course for you.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'Postgraduate Certificate',
		'Postgraduate',
		"Master's",
		'PhD',
		'Postgraduate Certificates & Diplomas',
	],
};

export const ACCESS_TO_HIGHER_EDUCATION_DATA: CourseDegreeCopy = {
	degreeLevel: 'access-to-higher-education',
	metadata: {
		title: 'Search Access to Higher Education Diplomas, UK',
		description:
			'Discover Access to Higher Education Diplomas in the UK. Explore student reviews, fees, grants, and find information on Access to Higher Education Diplomas at Uni Compare.',
	},
	headerData: {
		title: 'Access to Higher Education Diplomas',
		description:
			"Use our Access to Higher Education Diplomas search to find a course at a UK university. Explore Access to Higher Education Diplomas by subject, course name or the region you'd like to study in. Easily find the perfect access to higher education diplomas with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Access to Higher Education Diploma courses',
		description:
			'Access to Higher Education Diplomas are a great choice for those with no prior qualifications looking to go on to an undergraduate degree. Browse course options, subjects available and learn more about what the course means for your future.',
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'Access to Higher Education',
		'Undergraduate',
		"Bachelor's",
		'Foundation',
		'Undergraduate Certificates & Diplomas',
	],
};

export const FOUNDATION_DATA: CourseDegreeCopy = {
	degreeLevel: 'foundation',
	metadata: {
		title: 'Search Foundation Degrees, UK',
		description:
			'Discover foundation degrees in the UK. Explore student reviews, fees, grants, and find information on foundation degrees at Uni Compare.',
	},
	headerData: {
		title: 'Foundation degrees',
		description:
			"Use our foundation degrees search to find a course at a UK university. Explore foundation degrees by subject, course name or the region you'd like to study in. Easily find the perfect foundation degrees with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Find foundation degrees',
		description:
			'Bring together your academic knowledge and hands-on skills in a foundation degree that will jumpstart your career! Explore your course options, choose a specific subject or filter to a chosen region to find a course that matches your needs.',
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		'Foundation',
		'Undergraduate',
		"Bachelor's",
		'Undergraduate Certificates & Diplomas',
	],
};

export const DEGREES_DATA: CourseDegreeCopy = {
	degreeLevel: 'degrees',
	metadata: {
		title: 'Search Degrees, UK',
		description:
			'Discover degrees in the UK. Explore student reviews, fees, grants, and find information on degrees at Uni Compare.',
	},
	headerData: {
		title: 'Degrees & courses',
		description:
			"Use our degrees search to find a degree course at a UK university. Explore degrees by subject, course name or the region you'd like to study in. Easily find the perfect degrees with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover degree courses',
		description:
			"Degrees come in all shapes and sizes - Bachelor's degrees, joint honours and so many more possibilities for your future. We have all the information on degree entry requirements, funding, course options and more.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: [
		"Bachelor's",
		'Undergraduate',
		'Foundation',
		'Undergraduate Certificates & Diplomas',
	],
};

export const CLEARING_DATA: CourseDegreeCopy = {
	degreeLevel: 'clearing',
	metadata: {
		title: 'Search Clearing Courses [YEAR], UK',
		description:
			'Discover clearing courses [YEAR] in the UK. Explore student reviews, fees, grants, and find information on clearing courses at Uni Compare.',
	},
	headerData: {
		title: 'Clearing courses [YEAR]',
		description:
			"Use our clearing courses search to find a course at a UK university. Explore clearing courses by subject, course name or the region you'd like to study in. Easily find the perfect clearing courses with our search tool from thousands of options.",
	},
	pageIntro: {
		title: 'Discover Clearing courses [YEAR]',
		description:
			"It's not too late to find a [YEAR] spot at uni! If you haven't received an offer or have changed your mind about where you want to study, search Clearing courses available for [YEAR] entry. Find entry requirements, funding options and the numbers to directly contact universities in Clearing.",
	},
	showClearingAndDirectoryCTA: false,
	showDegreeLevelHubLinks: false,
	showViewAllSubjectsLink: true,
	degreeLevelLabels: ['Undergraduate', 'Postgraduate'],
};
